<template>
  <v-container class="admin-users">
    <v-app-bar app dark dense color="secondary">
      <v-toolbar-title>{{ $t("admin.users.title") }}</v-toolbar-title>
    </v-app-bar>

    <v-row>
      <v-col>
        <ApprovedUsers />
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" md="7">
        <PendingUsers />
      </v-col>

      <v-col cols="12" md="5">
        <StaffUsers />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ApprovedUsers from "@/components/Admin/Users/ApprovedUsers";
import PendingUsers from "@/components/Admin/Users/PendingUsers";
import StaffUsers from "@/components/Admin/Users/StaffUsers";

export default {
  components: {
    ApprovedUsers,
    PendingUsers,
    StaffUsers,
  },
};
</script>

<style lang="scss">
.admin-users th {
  white-space: nowrap;
}
</style>
